import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo';
import SocialIcons from './SocialIcons';

const COLUMN_HEADING =
  'font-display text-[11px] uppercase tracking-[1.8px] text-lk-ink/60 mb-1';
const COLUMN_LINK = 'text-sm text-lk-ink/70 transition-colors hover:text-lk-ink';

export default function SiteFooter() {
  return (
    <footer className="bg-paper">
      <div className="mx-auto max-w-[1440px]">
        <div className="grid grid-cols-2 gap-10 border-t border-lk-ink/10 px-5 pt-12 md:grid-cols-[1.4fr_1fr_1fr] md:px-14 md:pt-14">
          {/* Brand */}
          <div className="col-span-2 flex flex-col gap-4 md:col-span-1">
            <Link to="/" className="self-start" aria-label="lykbl home">
              <BrandLogo variant="auto" size="md" />
            </Link>
            <p className="max-w-[240px] text-[13.5px] leading-relaxed text-lk-ink/70">
              AI agent teams for review-ready creator growth and offer work.
            </p>
            <SocialIcons />
          </div>

          {/* Company */}
          <div className="flex flex-col gap-3">
            <div className={COLUMN_HEADING}>Company</div>
            <Link to="/about" className={COLUMN_LINK}>
              About
            </Link>
            <Link to="/help" className={COLUMN_LINK}>
              Contact
            </Link>
            <Link to="/help" className={COLUMN_LINK}>
              Help centre
            </Link>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-3">
            <div className={COLUMN_HEADING}>Legal</div>
            <Link to="/legal/terms" className={COLUMN_LINK}>
              Terms of service
            </Link>
            <Link to="/privacy" className={COLUMN_LINK}>
              Privacy policy
            </Link>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-2 px-5 pb-6 pt-8 text-[12.5px] text-lk-ink/60 sm:flex-row md:px-14">
          {/* Build year vs. visitor's year can differ around New Year. */}
          <span suppressHydrationWarning>© {new Date().getFullYear()} lykbl™. All rights reserved.</span>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 sm:justify-end">
            <span>say it: &ldquo;likeable&rdquo;</span>
            <a
              href="https://aiaiohhh.com/portfolio/lykbl?utm_source=lykbl.com&utm_medium=footer&utm_campaign=portfolio_backlink"
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-lk-ink/30 underline-offset-4 transition-colors hover:text-lk-ink focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lk-ink/40"
            >
              Built by AiAiOHHH
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
